const addProductVariantStyles = (theme) => ({
  variantContainer: {
    border: `1px solid ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
    padding: "20px",
    marginBottom: "20px",
    backgroundColor: theme?.palette?.customColor?.white || "#FFFFFF",
  },
  variantHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: `1px solid ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
  },
  variantTypeLabel: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  variantActions: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  editButton: {
    color: theme?.palette?.primary?.main || "#0F0F0F",
    "&:hover": {
      backgroundColor: theme?.palette?.action?.hover || "rgba(0, 0, 0, 0.04)",
    },
  },
  closeButton: {
    color: theme?.palette?.customColor?.red || "#D32F2F",
    "&:hover": {
      backgroundColor: theme?.palette?.action?.hover || "rgba(0, 0, 0, 0.04)",
    },
  },
  variantFields: {
    display: "flex",
    gap: "20px",
    alignItems: "flex-start",
    width: "100%",
    flexWrap: "wrap",
  },
  imageBox: {
    position: "relative",
    width: "68px !important",
    height: "68px",
    border: `1px dashed ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    cursor: "pointer",
  },
  variantImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imageCount: {
    width: "24px",
    height: "24px",
    border: `1px solid ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
    borderRadius: "50%",
    background: theme?.palette?.primary?.main || "#0F0F0F",
    color: theme?.palette?.customColor?.white || "#FFFFFF",
    position: "absolute",
    top: "4%",
    right: "4%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "17.5px",
  },
  fieldContainer: {
    minWidth: "200px",
    display: "flex",
    gap: "10px",
    "&:last-child": {
      flex: 0.5,
      minWidth: "120px",
    },
  },
  modalUploadWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  modalImageWrap: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  modalImageText: {
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  imageValidationWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  modalImageValidationText: {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 400,
    color: theme?.palette?.customColor?.secondarySecond || "#656565",
  },
  modalImagePreviewWrap: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "20px",
  },
  modalImagePreview: {
    position: "relative",
    width: "60px",
    height: "60px",
    border: `1px solid ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  loadingIcon: {
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  modalImageCrossIcon: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    cursor: "pointer",
    backgroundColor: theme?.palette?.customColor?.white || "#FFFFFF",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imagePreviewModal: {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: theme?.palette?.customColor?.backdrop || "rgba(0, 0, 0, 0.8)",
    p: 2,
    boxShadow: 24,
    borderRadius: "8px",
    minWidth: "100vw",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
  },
  cropperModal: {
    maxWidth: "40%",
    height: "60%",
    backgroundColor: "white",
    borderRadius: 2,
    boxShadow: 3,
    padding: 2,
  },
  imageCropDisplay: {
    height: "90%",
    width: "100%",
  },
});

export default addProductVariantStyles;

